<app-button-toggle-group
  [value]="value"
  [options]="options"
  (valueSelected)="onSelect($event)"
></app-button-toggle-group>
